import { OnInit, TemplateRef } from '@angular/core';
import { HeaderService } from '../services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagePopupService } from '../services/message-popup.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { BsModalService } from '../../../node_modules/ngx-bootstrap';
import { LoginService } from '../services/login.service';
import { Globals } from '../objects/Globals';
import { TokenManager } from '../Globals';
import { ConfirmationService } from '../services/confirmation.service';
import { ToasterService } from 'angular2-toaster';
import { SessionTimerService } from '../services/session-timer.service';
var AutologinComponent = /** @class */ (function () {
    function AutologinComponent(loginService, globals, router, 
    //public bsModalRef: BsModalRef | null,
    //private modalRef: BsModalRef,
    modalService, tokenManager, themeSettingService, confirmationService, toasterService, headerService, sessionTimerService, messagePopupService, route) {
        this.loginService = loginService;
        this.globals = globals;
        this.router = router;
        this.modalService = modalService;
        this.tokenManager = tokenManager;
        this.themeSettingService = themeSettingService;
        this.confirmationService = confirmationService;
        this.toasterService = toasterService;
        this.headerService = headerService;
        this.sessionTimerService = sessionTimerService;
        this.messagePopupService = messagePopupService;
        this.route = route;
        this.isBusy = true;
    }
    AutologinComponent.prototype.ngOnInit = function () {
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
        var oneTimeKey = this.route.snapshot.paramMap.get('oneTimeKey');
        var userId = this.route.snapshot.paramMap.get('userId') + "#external";
        this.login(userId, oneTimeKey);
    };
    AutologinComponent.prototype.login = function (username, password) {
        var _this = this;
        this.isBusy = true;
        var param = [];
        param.push({ name: 'username', value: username });
        param.push({ name: 'password', value: password });
        if (this.tokenManager.retrieve("BRNHoldKey")) {
            var value = this.tokenManager.retrieve("BRNHoldKey").replace(/["']/g, "");
            if (value != "null") {
                param.push({ name: 'holdKey', value: this.tokenManager.retrieve("BRNHoldKey").replace(/["']/g, "") });
            }
        }
        else if (this.tokenManager.retrieve("BRNActionKey")) {
            var value = this.tokenManager.retrieve("BRNActionKey").replace(/["']/g, "");
            if (value != "null") {
                param.push({ name: 'holdKey', value: this.tokenManager.retrieve("BRNActionKey").replace(/["']/g, "") });
            }
        }
        this.loginService.login(param).subscribe(function (result) {
            //this.bsModalRef.hide();
            if (result) {
                console.log(result);
                if (result.Session) {
                    _this.tokenManager.store("BRNHoldKey", null);
                    _this.redirectHome(result);
                    _this.isBusy = false;
                }
                else {
                    setTimeout(function () {
                        _this.confirmationService.confirmNoInput('<span class="bold">Confirmation</span>', result.HoldMessage, ["CANCEL", "OK"]).subscribe(function (respond) {
                            var newParam = [];
                            var index = param.findIndex(function (x) { return x.name == "holdKey"; });
                            if (index > -1) {
                                newParam.push(param.find(function (x) { return x.name == "holdKey"; }));
                            }
                            if (respond.answer == "OK") {
                                var config = {
                                    keyboard: false,
                                    ignoreBackdropClick: true,
                                    class: 'modal-dialog-centered modal-loading',
                                    focus: false,
                                    animated: false
                                };
                                _this.isBusy = true;
                                //this.modalRef = this.modalService.show(LoadingComponent, config);
                                _this.loginService.proceed(result.HoldId, true, newParam).subscribe(function (result) {
                                    if (result) {
                                        _this.tokenManager.store("BRNHoldKey", null);
                                        _this.redirectHome(result);
                                        //this.modalRef.hide();
                                        _this.isBusy = false;
                                    }
                                });
                            }
                            else if (respond.answer == "CANCEL") {
                                _this.loginService.proceed(result.HoldId, false, newParam).subscribe(function (result) {
                                    // if (result){
                                    _this.redirectHome(result);
                                    _this.isBusy = false;
                                    // }
                                });
                            }
                        });
                    }, 500);
                }
            }
            else {
                _this.isBusy = false;
                _this.messagePopupService.popMessage("Error", "Login is not valid.", ["OK"]).subscribe(function (respond) {
                    _this.redirectHome(result);
                });
                //this.submitted = false;
                //this.invalid.next(true);
            }
        }, function (error) {
            _this.isBusy = false;
            _this.messagePopupService.popMessage("Error", "Login is not valid.", ["OK"]).subscribe(function (respond) {
                _this.router.navigate(['/', 'home']);
            });
            //this.submitted = false;
            //this.tokenManager.store("BRNHoldKey", null)
        });
    };
    AutologinComponent.prototype.redirectHome = function (result) {
        this.globals.Session = result;
        this.loginService.setSession(result);
        this.headerService.setSessionAlive(true);
        this.sessionTimerService.startSessionTimer();
        this.router.navigate(['/', 'home']);
        document.querySelectorAll('.body-content').item(0).classList.remove('mb-login');
        document.querySelectorAll(".body-content").item(0).classList.remove('default');
        document.querySelectorAll('.navbar').item(0).classList.remove('mb-login');
        //this.invalid.next(false);
        this.globals.CardItems = [];
        this.tokenManager.delete("BRNCurrentMenu");
        if (this.globals.Session.Session.SessionId != null) {
            this.tokenManager.store('BRNSessionKey', this.globals.Session.Session.SessionId);
        }
        this.toasterService.clear();
    };
    return AutologinComponent;
}());
export { AutologinComponent };
